/** Shared ms timings for the quick-checkout savings pill + View Cart CTA. */

export const EXPAND_START_DELAY_MS = 200;

export const CTA_HIDE_MS = 250;

export const EXPANDED_HOLD_MS = 1200;

export const PILL_WIDTH_ANIMATION_MS = 450;

export const CTA_REVEAL_LEAD_MS = 300;
